<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">安装 FaxChain</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">安装 Go</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">安装二进制文件</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">开发人员工作流程</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(41)" class="s2"><a :class="{active:flag==41}" href="#box41">Sending to Other Networks</a></p>
            <p @click="activeted(42)" class="s2"><a :class="{active:flag==42}" href="#box42">Depositing and withdrawing from exchanges</a></p>
            <p @click="activeted(43)" class="s2"><a :class="{active:flag==43}" href="#box43">Adding Tokens</a></p>
          </div> -->
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">下一步</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(51)" class="s2"><a :class="{active:flag==51}" href="#box51">FaxChain Bridge</a></p>
            <p @click="activeted(52)" class="s2"><a :class="{active:flag==52}" href="#box52">Ecosystem</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">安装</div>
      <div id="box1" class="p2">安装FaxChain</div>
      <div class="p3">本指南将解释如何将exchaind和exchaincli入口点安装到您的系统上。将这些安装在服务器上后，您可以作为完整节点或 验证者参与测试网。</div>
      <div id="box2" class="p2">安装 Go</div>
      <div class="p3"><span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">go</span> 按照官方文档安装。请记住设置您的 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">$PATH</span> 环境变量，例如：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">mkdir -p $HOME/go/bin</div>
          <div style="padding:5px 0">echo "export PATH=$PATH:$(go env GOPATH)/bin" >> ~/.bash_profile</div>
          <div style="padding:5px 0">echo "export GOPATH=$HOME/go" >> ~/.bash_profile</div>
          <div style="padding:5px 0">echo "export GOBIN=$GOPATH/bin" >> ~/.bash_profile</div>
          <div style="padding:5px 0">echo "export PATH=$PATH:$GOBIN" >> ~/.bash_profile</div>
          <div style="padding:5px 0">source ~/.bash_profile</div>
        </div>
      </div>
      <div class="p3">在 Windows 下，您可以通过“系统”控制面板的“高级”选项卡上的“环境变量”按钮来设置环境变量（<span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">HOME</span>或<span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">GO111MODULE</span>）。GO111MODULE某些版本的 Windows 通过“系统”控制面板中的“高级系统设置”选项提供此控制面板。</div>
      <div class="p3">注意：FaxChain 需要Go 1.12+ 。</div>
      <div id="box3" class="p2">安装二进制文件</div>
      <div class="p3">接下来，让我们安装最新版本的 FaxChain。确保您是最新发布的版本。<span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">git checkout</span></div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">git clone -b < latest-release-tag > https://github.com/fax/exchain</div>
          <div style="padding:5px 0">export GO111MODULE=on</div>
          <div style="padding:5px 0">cd exchain && make install</div>
        </div>
      </div>
      <div class="p3">在 Windows 下，您可以在 PowerShell 上执行以下命令来设置环境变量 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">GO111MODULE</span>。</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># github.com/fax/exchain/cmd/exchaind</div>
          <div style="padding:5px 0">flag provided but not defined: -L</div>
          <div style="padding:5px 0">usage: link [options] main.o</div>
          <div style="padding:5px 0">...</div>
          <div style="padding:5px 0">make: *** [install] Error 2</div>
        </div>
      </div>
      <div class="p3">取消设置此环境变量，然后重试。</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">LDFLAGS="" make install</div>
        </div>
      </div>
      <div class="p3">注意：如果您在这一步仍有问题，请检查您是否安装了最新的稳定版 GO。</div>
      <div class="p3">这将安装exchaind和exchaincli二进制文件。验证一切正常：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaind version --long</div>
          <div style="padding:5px 0">$ exchaincli version --long</div>
        </div>
      </div>
      <div class="p3"><span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincli</span> 例如应该输出类似于：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">name: faxchain</div>
          <div style="padding:5px 0">server_name: exchaind</div>
          <div style="padding:5px 0">client_name: exchaincli</div>
          <div style="padding:5px 0">version: v0.18.10</div>
          <div style="padding:5px 0">commit: 20a720f38c6c60540a739351e485779a098ee413</div>
          <div style="padding:5px 0">build_tags: netgo</div>
          <div style="padding:5px 0">go: go version go1.14.2 darwin/amd64</div>
          <div style="padding:5px 0">cosmos_sdk: v0.37.9</div>
          <div style="padding:5px 0">tendermint: v0.32.10</div>
        </div>
      </div>
      <div id="box4" class="p2">开发人员工作流程</div>
      <div class="p3">要测试在 Cosmos-SDK 或 Tendermint 中所做的任何更改，replace需要添加一个子句来go.mod提供正确的导入路径。</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>进行适当的更改</li>
            <li>添加到 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">replace github.com/cosmos/cosmos-sdk => /path/to/clone/cosmos-sdk</span> <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">go.mod</span></li>
            <li>运行或 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">make install</span> <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">make build</span></li>
            <li>测试更改</li>
        </ul>
      </div>
      <div id="box5" class="p2">下一步</div>
      <div class="p3">现在您可以加入主网、公共测试网或创建自己的测试网</div>
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">安装 FaxChain</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">安装 Go</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">安装二进制文件</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">开发人员工作流程</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(41)" class="s2"><a :class="{active:flag==41}" href="#box41">Sending to Other Networks</a></p>
        <p @click="activeted(42)" class="s2"><a :class="{active:flag==42}" href="#box42">Depositing and withdrawing from exchanges</a></p>
        <p @click="activeted(43)" class="s2"><a :class="{active:flag==43}" href="#box43">Adding Tokens</a></p>
      </div> -->
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">下一步</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(51)" class="s2"><a :class="{active:flag==51}" href="#box51">FaxChain Bridge</a></p>
        <p @click="activeted(52)" class="s2"><a :class="{active:flag==52}" href="#box52">Ecosystem</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'getStart',
  data() {
    return {
      show: false
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>